import * as fb from 'firebase/app';
import '@firebase/firestore';
import '@firebase/database';

import { FIREBASE_CONFIG } from 'constants/firebase.constants';

export const firebase = fb.initializeApp(FIREBASE_CONFIG);

export const db = fb.firestore();
